import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { 
  setPaymentServiceData, getPaymentMethods, executeTaggeo, getUserInfo, 
  getUserInfoLite, setReloadInfoAfterAddingCard, setIsAnonimous,
  setAdvancementPayMethod, setShowAdvancementMiniBanner,
  setCreditCardInfo,
} from '../../store/actions';
import {createTooltipFavorite,getTooltipFavorite,getFavoritosRef} from '../../store/actions/favoritosRef.js';
import { 
  selectContactNumberData, getBundleIdFromUrl, getUserInfoSelector, 
  getMessageFavServices, getListFavsServices, getUserInfoLiteSelector,
  getTagServiceId
} from '../../store/selectors/paymentsSelectors'
import { getMessagesFavoritesServices } from '../../store/actions/favoritosRef.js';
import ToolTipTelcelAvisos from '../organisms/TooltipTelcelAvisos';
import { getMessage } from "../organisms/utils.js";
import HeaderPaymentFormClaroSocio from "../organisms/HeaderPaymentFormClaroSocio";
import HeaderPaymentForm from '../organisms/HeaderPaymentForm'
import BodyPaymentFormClaroSocio from "../organisms/BodyPaymentFormClaroSocio";
import styled from 'styled-components';
import ModalCardOk from '../molecules/ModalCardOk'
import ClaroVideoCarousel from '../molecules/ClaroVideoCarousel'
import { GenericFormContext } from '../../context/genericFormContext';
import * as sdkclaro from '@claro/sdkclaromicrofront';
import ModalCardLoader from '../molecules/ModalCardLoader'
import { calculateOriginPayment } from '../organisms/GenericForm/utils/calculateOriginPayment.js';
import {
  TELMEX,
  AMIGO_PAGUITOS,
  CATEGORY_PLANS_ID_PAQUETE_INTERNET_AMIGO,
  CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE,
  SERVICE_ID_TELCEL_POSPAGO,
  SERVICE_ID_TELCEL_PLANES,
  SERVICE_ID_TELCEL_RECARGA
} from '../../constants';
import { ClaroSDKService } from '../../services/sdk/ClaroSDKService.js';
const Container = styled.div`
  width: 100%;
  height:100%;
  background: ${props => props.background ? props.background : '#fff'};
  overflow: scroll;
`;

const Footer = styled.div`
  width: 100%;
  height:1%;
`;
class PaymentFormClaroSocioContainer extends Component {


  constructor(props, context) {
    super(props, context)
    this.title = React.createRef();
    this.handleClickScroll = this.handleClickScroll.bind(this);
    this.state = {
      index: 0,
      dontShowAgain:undefined,
      closePopUpMejoramos: false,
      serviceConfig: this.props.paymentsConfig.services[this.props.serviceConfigIndex].serviceData.generic,
      serviceInfo: this.props.paymentsConfig.services[this.props.serviceConfigIndex].serviceData.info,
      msisdnToTaggeo: {},
      showAdvancementPayMethodInList: false,
      validateIfSentToTicket: false,
      showLoaderWaitSubmit: false
    }
    this.handleShowLoaderWaitSubmit = this.handleShowLoaderWaitSubmit.bind(this);
  }
  
  handleShowLoaderWaitSubmit(value) {
		this.setState({showLoaderWaitSubmit: value})
	}

  componentDidMount() {
    const { 
      originOfPayment, executeTaggeo, paymentsConfig, isContainerTelcel,canFavoriteTooltip,
      canManageFavorites, sdkVersion, getPaymentMethods, paymentMethods, isAnonimous,
    } = this.props
    const { 
      serviceInfo: { logicType, categoryPlansId, serviceId },
      serviceConfig 
    } = this.state

    if(canFavoriteTooltip){
      this.assignTagServiceTelcel(serviceId);
    }
    this.props.getMessagesFavoritesServices('PagoServicios');

    if (sdkVersion !== undefined && !isAnonimous) {
      getPaymentMethods(serviceId, false);
    }

    if (logicType == "claroVideo") {
      this.setState({ renderCarousel: true })
      setInterval(() => {
        let indexAutoplay = this.state.index
        if (indexAutoplay >= 4) {
          indexAutoplay = -1;
        }
        this.setState({ index: indexAutoplay + 1 });
      }, 3500)
    }
    if (
      (
        originOfPayment &&
        originOfPayment !== "Home" &&
        serviceId === TELMEX
      )
      || serviceId === AMIGO_PAGUITOS
      || serviceId === SERVICE_ID_TELCEL_POSPAGO
      || categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_INTERNET_AMIGO
      || categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE
    ) {
      setTimeout(() => {
        executeTaggeo({
          step: "Formulario de pago",
          action: "View",
          service: paymentsConfig.tagServiceId,
          origin: calculateOriginPayment(originOfPayment)
        })
      }, 500);
    }
    setTimeout(() => {
      const buttonBoxElement = serviceConfig.elements.find(element => element.id === 'buttonBox');
      if (
          buttonBoxElement && 
          buttonBoxElement.cp && 
          Boolean(buttonBoxElement.cp.find(input => input.id === 'favoritos')) && 
          !isContainerTelcel && 
          canManageFavorites  && this.props.isClaroPartner === false && this.props.hasTooltipSucces
      ){
        if(!this.props.hasTooltipSucces.favoriteTooltip[0]){
        this.setState({ closePopUpMejoramos: true })
        console.log(this.props.hasTooltipSucces);
        executeTaggeo({
          step: "Formulario de pago",
          action: "View message",
          id_message: "Mejoramos tu experiencia",
          service: this.state.tagServiceId
        })
      }
      }
    }, 2900);
    if(paymentMethods && paymentMethods.hasAdvancement){
      this.showMiniBanner();
    }
  }

  assignTagServiceTelcel(serviceId) {
    let newTagServiceId;

    switch (true) {
        case (serviceId === SERVICE_ID_TELCEL_PLANES):
            newTagServiceId = 'telcelAmigoSinLimitePs';
            break;
        case (serviceId === SERVICE_ID_TELCEL_POSPAGO):
            newTagServiceId = 'TelcelPospagoPS';
            break;
            case (serviceId === AMIGO_PAGUITOS):
              newTagServiceId = 'amigopaguitos';
              break;
        case (serviceId === SERVICE_ID_TELCEL_RECARGA):
            newTagServiceId = 'serviciopagotelcel';
            break;
        default:
            newTagServiceId = this.props.paymentsConfig.tagServiceId;
    }

    if (this.state.tagServiceId !== newTagServiceId) {
      this.setState({ tagServiceId: newTagServiceId })
          this.props.getTooltipFavorite(newTagServiceId);
      };
}


  postChange = (e) => {
    if (e.activeIndex > 4) {
      this.setState({ index: 4 })
    } else {
      this.setState({ index: e.activeIndex })
    }
  }

  handleCheck = (e) => {
    this.setState({ index: e.target.id })
  }

  handleClickScroll(event) {
    this.title.current.scrollIntoView({ behavior: 'smooth' })
  }

  onclickCloseModal = (e) => {
    sdkclaro.getInstance().closeMicroFront();
  }

  componentDidUpdate(prevProps) {
    const {
      reloadInfoAfterAddingCard, paymentMethods, userInfo,canFavoriteTooltip
    } = this.props
    if(this.state.dontShowAgain === undefined && canFavoriteTooltip) {
    if(this.props.hasTooltipSucces.favoriteTooltip && this.props.hasTooltipSucces.favoriteTooltip.length !== 0){
        this.setState({ dontShowAgain:true })
      }
    }

    if (prevProps.reloadInfoAfterAddingCard != reloadInfoAfterAddingCard) {
      console.log("****LOGGUED IN SUCCESS****");
      this.props.getUserInfo();
      this.props.setCreditCardInfo(undefined);
    }

    if (prevProps.userInfo !== userInfo && reloadInfoAfterAddingCard) {
      this.props.getPaymentMethods(this.state.serviceInfo.serviceId, false);
    }

    if (prevProps.paymentMethods !== paymentMethods) {
      const { cardList, hasN2, hasAdvancement } = paymentMethods;
      if (reloadInfoAfterAddingCard) {

        if (cardList && cardList.length === 0 && !hasN2) {
          ClaroSDKService.openInvitation();
        }

        if (cardList && (cardList.length > 0 || hasN2)) {
          this.props.setIsAnonimous(false);
        }
      }
      if(hasAdvancement){
        this.showMiniBanner();
      }
    }
  }

  showMiniBanner= () => {
    const {
			userInfoLite : {advancePayment},
			amountPlan,
      setShowAdvancementMiniBanner,
      isAdvancementClaroPay, setAdvancementPayMethod
		} = this.props
    const { 
      serviceInfo: { serviceId },
    } = this.state

		const canShowSnackBar = advancePayment &&
			advancePayment.creditAmount 
			if (
        serviceId === SERVICE_ID_TELCEL_PLANES && canShowSnackBar && 
        amountPlan <= advancePayment.creditAmount
      ) {
        if(isAdvancementClaroPay){
          setAdvancementPayMethod(true)
        } else{
          setShowAdvancementMiniBanner(true)
        }
        this.setState({showAdvancementPayMethodInList: true})
        this.taggeoSnackbar("View minibanner");
      }else{
        setShowAdvancementMiniBanner(false)
      }
  }

  taggeoFavoritosv = (action) =>{
    this.props.executeTaggeo({
      step: "Formulario de pago",
      action: action,
      id_message: "Mejoramos tu experiencia",
      service: this.state.tagServiceId
    })
    this.setState({ closePopUpMejoramos: false })
  }

  taggeoSnackbar = (action) => {
		const { executeTaggeo } = this.props;
		executeTaggeo({
			eventName: "pay_service_or_tae",
			step: "Formulario de pago",
			action: action,
			banner_id: "Adelanto disponible Telcel",
			service: this.props.tagServiceId
		});
	}

  handleOnclickMiniBanner = () => {
    this.props.setAdvancementPayMethod(true)
    this.taggeoSnackbar("Click minibanner");
  }

  handleValidateIfSentToTicket = (value) => {
		this.setState({validateIfSentToTicket: value})
	}

  render() {
    const { 
      paramsNewOfferTelcel, history, isContainerTelcel, paymentsConfig, isLoadingGetPaymentMethods,
      errorPaymentMethods, paymentMethods, getPaymentMethods, appSyncValues, listMessagesFavServices,
      showAdvancementMiniBanner, isClaroPartner 
    } = this.props
    const {
      serviceInfo : {serviceId, serviceTitleLabel}, openModalCloseMicroApp, showAdvancementPayMethodInList,
      closePopUpMejoramos, serviceConfig
    } = this.state
    if (paymentsConfig) {
      if (!isLoadingGetPaymentMethods) {
        if (errorPaymentMethods && paymentMethods == undefined) {
          this.context.setCountPaymentMethods(this.context.countPaymentMethodsCall + 1, 2)
          if (this.context.countPaymentMethodsCall < 2) {
            getPaymentMethods(serviceId, false);
          } else {
            if (!openModalCloseMicroApp) {
              this.setState({ openModalCloseMicroApp: true })
            }
          }
        }
      }

      return (
        <>
          <Container background={isContainerTelcel && !isClaroPartner ? "#fff" : undefined}>
            {
              (isClaroPartner) ?
                <HeaderPaymentFormClaroSocio dataConfigLogo={serviceConfig.logo.data} {...this.state.serviceInfo} /> :
                <HeaderPaymentForm
                  dataConfigLogo={serviceConfig.logo.data}
                  serviceTitleLabel={serviceTitleLabel}
                  isContainerTelcel={isContainerTelcel}
                  showAdvancementMiniBanner={showAdvancementMiniBanner}
                  appSyncValues={appSyncValues}
                  handleOnclickMiniBanner={this.handleOnclickMiniBanner}
                  serviceId={serviceId}
                />
            }
            {
              (
                this.props.sdkVersion == undefined ||
                (
                  this.props.sdkVersion !== undefined && 
                  (this.props.paymentMethods || this.props.isAnonimous)&&
                  !this.props.isLoadingAppSync
                )) ?
                <>

                  <BodyPaymentFormClaroSocio
                    dataConfigInputs={this.state.serviceConfig.elements}
                    tooltipHeight={this.state.serviceConfig.tooltipHeight}
                    textTitleTooltip={this.state.serviceConfig.textTitleTooltip}
                    textTitleTooltipFontSize={this.state.serviceConfig.textTitleTooltipFontSize}
                    textTitleTooltipFontColor={this.state.serviceConfig.textTitleTooltipFontColor}
                    textTitleTooltipMargin={this.props.isContainerTelcel ? "0px 0px 15px 0px" : this.state.serviceConfig.textTitleTooltipMargin}
                    imgTooltip={this.state.serviceConfig.imgTooltip}
                    imgTooltipPosition={this.state.serviceConfig.imgTooltipPosition}
                    imgTooltipWidth={this.state.serviceConfig.imgTooltipWidth}
                    serviceName={this.state.serviceInfo.serviceName}
                    paymentType={this.state.serviceInfo.paymentType}
                    serviceId={this.state.serviceInfo.serviceId}
                    contactNumber={this.props.contactNumber}
                    feeAmount={this.state.serviceConfig.amount.feeAmount}
                    configImgService={this.state.serviceConfig.logo.data.base64}
                    destAccountIdType={this.state.serviceInfo.destAccountIdType}
                    multipleServiceIds={this.state.serviceInfo.multipleServiceIds}
                    sdkVersion={this.props.sdkVersion}
                    isClaroPartner={this.props.isClaroPartner}
                    setPaymentServiceData={this.props.setPaymentServiceData}
                    serviceInfo={this.state.serviceInfo}
                    amountPlan={this.props.amountPlan}
                    productIdFromPlan={this.props.productId}
                    handleClickScroll={this.handleClickScroll}
                    tagServiceId={this.props.paymentsConfig.tagServiceId}
                    infoPlanSears={this.props.infoPlanSears}
                    noInternet={this.props.noInternet}
                    searsCardNumber={this.props.searsCardNumber}
                    paramsNewOfferTelcel={paramsNewOfferTelcel}
                    paymentCard={this.props.paymentCard}
                    isContainerTelcel={this.props.isContainerTelcel}
                    msisdnToTaggeo={this.state.msisdnToTaggeo}
                    planCategory={this.props.planCategory}
                    planBenefits={this.props.planBenefits}
                    history={history}
                    listFavServices={this.props.listFavServices}
                    canManageFavorites={this.props.canManageFavorites}
                    showAdvancementPayMethodInList={showAdvancementPayMethodInList}
                    validateIfSentToTicket={this.state.validateIfSentToTicket}
                    handleValidateIfSentToTicket={this.handleValidateIfSentToTicket}
                    handleShowLoaderWaitSubmit={this.handleShowLoaderWaitSubmit}
                    showLoaderWaitSubmit={this.state.showLoaderWaitSubmit}
                  />
                  <Footer innerRef={this.title}></Footer>
                </>

                : <></>
            }
            {
              (this.state.serviceInfo.logicType == "claroVideo") ?
                <ClaroVideoCarousel
                  postChange={this.postChange}
                  index={this.state.index}
                  handleCheck={this.handleCheck}>
                </ClaroVideoCarousel> :
                <></>
            }
            <ModalCardLoader
              isOpen={
                !this.state.showLoaderWaitSubmit && (
                  this.props.isLoadingGetPaymentMethods && this.props.isLoadingAppSync
                )
              }
            />
          </Container>
          {

            <>
              {getMessage(listMessagesFavServices, 'CP0532') && !this.state.dontShowAgain &&(
                <ToolTipTelcelAvisos
                  tooltipInformation={getMessage(listMessagesFavServices, 'CP0532')}
                  isOpen={!openModalCloseMicroApp && closePopUpMejoramos}
                  handleNextAction={
                    () => {
                      this.taggeoFavoritosv("Click message Entendido")
                    }
                  }
                  handleDontShowAgain={
                    () => {
                      if(this.props.canFavoriteTooltip){
                        this.props.createTooltipFavorite(this.state.tagServiceId);
                      }
                     this.taggeoFavoritosv("Click message No volver a mostrar")
                    }
                  }
                />
                )}
            </>
          }
          <ModalCardOk
            isOpen={this.state.openModalCloseMicroApp}
            srcImage="data:image/png;base64,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"
            text={"¡Uy, algo pasó!"}
            buttontext={"Ok"}
            textdetail={"Por el momento este servicio no está disponible. Por favor, intenta más tarde."}
            onclickModal={this.onclickCloseModal}
            fontFamilyTextdetail={isContainerTelcel ? "AMX-Regular" : undefined}
            fontSizeDetail={isContainerTelcel ? "16px" : "12px"}
            fontFamilyTitle={isContainerTelcel ? "AMX-Bold" : undefined}
            fontSizeTitle={isContainerTelcel ? "20px" : undefined}
            fontFamilyButton={isContainerTelcel ? "AMX-Bold" : undefined}
            fontSizeButton={isContainerTelcel ? "16px" : undefined}
            backgroundColorButton={isContainerTelcel ? "#7b1fa2" : undefined}
            colorButton={isContainerTelcel ? "#ffffff" : undefined}
          />
        </>
      )
    }
    return <div>Config not found...</div>
  }
}

PaymentFormClaroSocioContainer.contextType = GenericFormContext;

function mapStateToProps(state) {
  const { payments, favoritesRefReducer } = state;
  const contactNumber = selectContactNumberData(payments)
  const bundleId = getBundleIdFromUrl(state);
  const userInfo = getUserInfoSelector(state);
  const userInfoLite = getUserInfoLiteSelector(state);
  const reloadInfoAfterAddingCard = payments.reloadInfoAfterAddingCard;
  const listMessagesFavServices = getMessageFavServices(favoritesRefReducer);
  const listFavServices = getListFavsServices(favoritesRefReducer);
  const {showAdvancementMiniBanner} = state.payments
  const tagServiceId = getTagServiceId(payments)
  return {
    contactNumber,
    isLoadingGetPaymentMethods: state.payments.isLoadingGetPaymentMethods,
    paymentMethods: state.payments.paymentMethods,
    errorPaymentMethods: state.payments.errorPaymentMethods,
    trackId: state.payments.trackId,
    originOfPayment: payments.originOfPayment,
    lineNumber: payments.lineNumber,
    isContainerTelcel: (bundleId == "com.telcel.contenedor" || bundleId == "com.telcel.contenedor.uat") ? true : false,
    userInfo: userInfo,
    isAnonimous: payments.isAnonimous,
    reloadInfoAfterAddingCard,
    listMessagesFavServices,
    canManageFavorites: payments.canManageFavorites,
    canFavoriteTooltip: payments.canFavoriteTooltip,
    listFavServices,
    userInfoLite,
    showAdvancementMiniBanner,
    tagServiceId:tagServiceId,
    hasTooltipSucces: favoritesRefReducer.ResponseSuccess,
    appSyncValues: payments.appSyncValues,
    isLoadingAppSync: payments.isLoadingAppSync,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getTooltipFavorite,
      createTooltipFavorite,
      setPaymentServiceData,
      getPaymentMethods,
      executeTaggeo,
      getUserInfo,
      getUserInfoLite,
      setReloadInfoAfterAddingCard,
      setIsAnonimous,
      getMessagesFavoritesServices,
      setAdvancementPayMethod,
      setShowAdvancementMiniBanner,
      setCreditCardInfo
    },
    dispatch,
  );
}

PaymentFormClaroSocioContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentFormClaroSocioContainer);


export default PaymentFormClaroSocioContainer